import { useMutation, gql } from "@apollo/client"

const DELETEPOST_MUTATION = gql`
  mutation DeletePost($id: ID!) {
    deletePost(id: $id)
  }
`

const useMutationDeletePost = () => useMutation(DELETEPOST_MUTATION)

export { useMutationDeletePost }
